module.exports = __webpack_public_path__ + "static/media/robert43.1b5051d4.png";